/**
 * @file
 * @prettier
 */

/**
 * Allows deep-linking into accordion sections
 * @returns
 */
export function openPageSectionAccordiansForDeepLink() {
  if (!location.hash.startsWith("#")) {
    return;
  }
  const jQueryElements = $(`[id$='${location.hash.substring(1)}']`);
  const target = jQueryElements.find(".pageSection").find("input");
  target.each((i, e) => {
    e.checked = true;
  });
}

export function InitializeFAQPage() {
  openPageSectionAccordiansForDeepLink();
}
